var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcePellets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ice_x5F_pellets",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0072F5",
    d: "M13.5059,20.9617l-1.531-3.696l-3.695,1.531l1.531,3.696 L13.5059,20.9617z M9.5079,13.5866l-1.848,0.765l0.766,1.848l1.847-0.7659L9.5079,13.5866z M4.7979,15.3206l-1.848,0.7661 l0.766,1.847l1.847-0.764L4.7979,15.3206z M17.4899,13.4897l-1.848,0.765l0.765,1.848l1.848-0.765L17.4899,13.4897z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5DEE8",
    d: "M20.4719,4.9827c0.106-0.255,0.4-0.3769,0.654-0.27 c0.255,0.105,0.376,0.3981,0.27,0.6531l-2.679,6.468c-0.08,0.192-0.266,0.3079-0.462,0.3079c-0.064,0-0.129-0.0109-0.191-0.038 c-0.255-0.105-0.376-0.3981-0.271-0.6531L20.4719,4.9827z M14.2919,2.0388c0.255,0.105,0.376,0.398,0.27,0.6529l-3.827,9.2381 c-0.079,0.1929-0.266,0.309-0.462,0.309c-0.064,0-0.129-0.012-0.191-0.0381c-0.255-0.1059-0.376-0.3979-0.271-0.6529l3.827-9.2389 C13.7439,2.0527,14.0379,1.9308,14.2919,2.0388z M8.1629,5.8908c0.106-0.255,0.4-0.3772,0.653-0.27 c0.255,0.105,0.376,0.3979,0.271,0.6529l-3.062,7.391c-0.079,0.192-0.266,0.3081-0.462,0.3081c-0.064,0-0.129-0.0111-0.191-0.0381 c-0.255-0.105-0.376-0.3979-0.271-0.6529L8.1629,5.8908z M16.1059,5.9876c0.105-0.255,0.399-0.3769,0.653-0.27 c0.255,0.105,0.376,0.3981,0.271,0.6531l-3.827,9.2389c-0.08,0.1931-0.266,0.309-0.462,0.309c-0.064,0-0.129-0.012-0.191-0.038 c-0.255-0.1061-0.376-0.399-0.271-0.654L16.1059,5.9876z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcePellets);
export default __webpack_public_path__ + "static/media/ice_pellets.7003982c30f9eb22248767d39a553a74.svg";
export { ForwardRef as ReactComponent };